var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nipponia-basic",attrs:{"id":"nipponia-basic"}},[(!!_vm.$route.meta.single)?[_c('router-view')]:[_c('Layout')],_c('intro-vue',{staticClass:"hhh",attrs:{"show":_vm.showStart},on:{"close":_vm.toggleShowStart}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }